module.exports = __webpack_public_path__ + "img/analytics.2340f43f.png";